import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@mui/material';
import { ReactComponent as ContentCopy } from '@/img/bookings/copy.svg';

const BankDetailRow = ({ labelKey, value, onCopy }) => {
	const { t } = useTranslation();

	return (
		<div className="bank-transfer__detail-field">
			<div className="bank-transfer__detail-label">{t(labelKey)}:</div>
			<div className="bank-transfer__detail-value-wrap">
				<span className="bank-transfer__detail-value">{value}</span>
				<IconButton size="small" onClick={() => onCopy(value)}>
					<ContentCopy width={16} height={16} />
				</IconButton>
			</div>
		</div>
	);
};

export default BankDetailRow;
